module.exports = __webpack_public_path__ + "static/media/play-store.5ff4055b.png";